<template>
  <hic-list-page :entities="entities" :condition="condition" @load="query" :loading="meta.loading" title="检查" keywordPlaceholder="检查项目名称、床位号" hide-search-dialog>
     <template slot="search">
      <el-switch v-model="ifSearchAll" active-text="全部" inactive-text="待检查" @change="query()" style="margin-right:1em"></el-switch>
      <el-date-picker type="daterange" v-model="meta.dateRange" size="small" range-separator="至" start-placeholder="申请开始日期" end-placeholder="申请结束日期" placeholder="申请日期" style="width: 270px" @change="dateChange" ></el-date-picker>
    </template>

    <el-table-column v-if="ifSearchAll" label="操作 " key="action" align="center" width="100">
      <template #default="{ row }">
        <el-button v-if="row.attachmentId" slot="reference" type="warning" size="mini" icon="el-icon-document" circle plain title="查看报告" @click="view(row)" />
      </template>
    </el-table-column>
    <el-table-column v-if="ifSearchAll" label="状态" prop="state" key="state" align="center" min-width="100" :filters="dictEnum.PacsRecordState" column-key="states">
      <template slot-scope="{ row }">
        <el-tag v-if="row.state == '待检查'" type="primary" size="small" hit effect="dark">{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '报告发出'" type="success" size="small" hit effect="dark">{{ row.state }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="申请号" prop="pacsApplyNo" key="pacsApplyNo" align="center" min-width="160"></el-table-column>
    <el-table-column label="检查号" prop="pacsStudyId" key="pacsStudyId" align="center" min-width="160"></el-table-column>
    <el-table-column label="床位号" prop="bedNo" key="bedNo" min-width="100"></el-table-column>
    <el-table-column label="患者姓名" prop="patientName" key="patientName" min-width="120"></el-table-column>
    <el-table-column label="性别" prop="patientGender" key="patientGender" align="center" min-width="80">
      <template slot-scope="{ row }">
        {{ row.patientGender | dictText("Gender") }}
      </template>
    </el-table-column>
    <el-table-column label="年龄" prop="patientAge" key="patientAge" align="center" min-width="80"></el-table-column>
    <el-table-column label="检查项目" prop="name" key="name" min-width="260"></el-table-column>
    <el-table-column label="开嘱医生" prop="issuedDoctorName" key="issuedDoctorName" min-width="100"></el-table-column>
    <el-table-column label="申请时间" prop="issuedTime" key="issuedTime" align="center" min-width="160"></el-table-column>
    <el-table-column label="执行护士" prop="execNurseName" key="execNurseName" min-width="100"></el-table-column>
    <el-table-column label="检查时间" prop="pacsStudyExecTime" key="pacsStudyExecTime" align="center" min-width="160"></el-table-column>
    <el-table-column label="报告时间" prop="pacsStudyReportTime" key="pacsStudyReportTime" align="center" min-width="160"></el-table-column>
    <el-table-column label="报告医生" prop="pacsStudyReportUserName" key="pacsStudyReportUserName" min-width="100"></el-table-column>
    <el-table-column label="审核医生" prop="pacsStudyVerifyUserName" key="pacsStudyVerifyUserName" min-width="100"></el-table-column>
  
  </hic-list-page>
</template>
<script>
  import { mapGetters } from "sw-hic";
  import api from "./api";
  export default {
    data() {
      return {
        meta: {
          loading: false,
          dateRange: [],
        },
        condition: {
          state: null,
          sort: "issuedTime,id",
          asc: false,
          pageSize: 20,
          pageIndexOnView: 1,
        },
        entities: {},
        ifSearchAll: false,
      }
    },
    computed: {
      ...mapGetters(["dictEnum", "user", "setting"]),
    },
    methods: {
      query() {
        this.meta.loading = true;
        if (this.ifSearchAll) {
          this.condition.state = null;
        } else {
          this.condition.state = '待检查';
          this.condition.states = null;
        }
        api.PacsRecord.query(this.condition)
          .then((res) => {
            this.$set(this, "entities", res);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      dateChange(v) {
        if (v) {
          if (Array.isArray(v)) {
            this.condition.issuedTimeStart = this.$utils.Fmt.startDatetime(v[0]);
            this.condition.issuedTimeEnd = this.$utils.Fmt.endDatetime(v[1]);
          } else {
            this.condition.issuedTimeStart = this.$utils.Fmt.startDatetime(v);
            this.condition.issuedTimeEnd = this.$utils.Fmt.endDatetime(v);
          }
        } else {
          this.condition.issuedTimeStart = null;
          this.condition.issuedTimeEnd = null;
        }
        this.query();
      },
      view(row) {
        api.Attachment.get(row.attachmentId)
          .then((res) => {
            window.open('/api' + res.url, '_blank');
          })
          .finally(() => {
          });
      },
    }
  }
</script>
<style>
.el-tag {
  white-space: pre-wrap;
  height: auto;
}
</style>